import { RouteRecordRaw, createRouter, createWebHashHistory } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    redirect: '/home',
    component: () => import('/@views/layout/index.vue'),
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          icon: 'UserOutlined',
        },
        component: () => import('/@/views/dashboard/index.vue'),
      },
      {
        path: '/product',
        name: '产品方案',
        component: () => import('/@/views/product/index.vue'),
      },
      {
        path: '/product/digital-governance',
        name: '数字治理',
        component: () => import('/@/views/product/digitalGovernance.vue'),
      },
      {
        path: '/product/digital-infrastructure',
        name: '数字基建',
        component: () => import('/@/views/product/digitalInfrastructure.vue'),
      },
      {
        path: '/product/data-element',
        name: '数据要素',
        component: () => import('/@/views/product/dataElement.vue'),
      },
      {
        path: '/product/digital-culture-tourism',
        name: '数字文旅',
        component: () => import('/@/views/product/digitalCultureTourism.vue'),
      },
      {
        path: '/case',
        name: '项目案例',
        component: () => import('/@/views/caseExample/index.vue'),
      },
      {
        path: '/case/produce',
        name: '项目详情',
        component: () => import('/@/views/caseExample/produce.vue'),
      },
      {
        path: '/news',
        name: '最新动态',
        component: () => import('/@/views/recentNews/index.vue'),
      },
      {
        path: `/news/articles`,
        name: '文章',
        component: () => import('/@/views/recentNews/article.vue'),
      },
      {
        path: '/about',
        name: '关于我们',
        component: () => import('/@/views/about/index.vue'),
      },
      {
        path: '/about/add',
        name: '加入我们',
        component: () => import('/@/views/about/add.vue'),
      },
      {
        path: '/about/post',
        name: '岗位',
        component: () => import('../views/about/postDetails.vue'),
      },
    ],
  },
  {
    path: '/phoneHome',
    redirect: '/phoneHome',
    component: () => import('/@views/layout/index.vue'),
    children: [
      {
        path: '/phoneHome',
        name: 'phoneHome',
        meta: {
          icon: 'UserOutlined',
        },
        component: () => import('/@/views/phone/phome/index.vue'),
      },
      {
        path: '/phoneProduct',
        component: () => import('/@/views/phone/pProduct/index.vue'),
      },
      {
        path: '/phoneProduct/digital-governance',
        component: () => import('/@/views/phone/pProduct/digitalGovernance.vue'),
      },
      {
        path: '/phoneProduct/digital-infrastructure',
        component: () => import('/@/views/phone/pProduct/digitalInfrastructure.vue'),
      },
      {
        path: '/phoneProduct/data-element',
        component: () => import('/@/views/phone/pProduct/dataElement.vue'),
      },
      {
        path: '/phoneProduct/digital-culture-tourism',
        component: () => import('/@/views/phone/pProduct/digitalCultureTourism.vue'),
      },
      {
        path: '/phoneCase',
        component: () => import('/@/views/phone/pCase/index.vue'),
      },
      {
        path: '/phoneCase/produce',
        component: () => import('/@/views/phone/pCase/produce.vue'),
      },
      {
        path: '/phoneNews',
        component: () => import('/@/views/phone/pNews/index.vue'),
      },
      {
        path: `/phoneNews/articles`,
        component: () => import('/@/views/phone/pNews/article.vue'),
      },
      {
        path: '/phoneAbout',
        component: () => import('/@/views/phone/pAbout/index.vue'),
      },
      {
        path: '/phoneAbout/add',
        component: () => import('/@/views/phone/pAbout/add.vue'),
      },
      {
        path: '/phoneAbout/post',
        component: () => import('../views/phone/pAbout/postDetails.vue'),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
